if (!customElements.get('mobile-search')) {
  customElements.define(
    'mobile-search',
    class MobileSearch extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.input = this.els.input.element
        this.closeButton = this.els.closeButton.element
        this.searchIcon = this.els.searchIcon.element

        this.initialize()
      }

      initialize () {
        this.setupListeners()
      }

      setupListeners () {
        this.input.addEventListener('keyup', this.setInputHasValue.bind(this))
        this.input.addEventListener('focus', this.setInputIsFocused.bind(this))
        this.closeButton.addEventListener(
          'click',
          this.handleCloseSearch.bind(this),
        )
      }

      handleCloseSearch () {
        this.input.value = ''
        this.setIconVisibility(false)
        document.body.classList.toggle('lyt-Site-searchIsActive', false)
      }

      setInputHasValue (event) {
        const inputHasValue = event.target.value.length > 0
        this.setIconVisibility(inputHasValue)
        document.body.classList.toggle('lyt-Site-searchIsActive', inputHasValue)
      }

      setInputIsFocused () {
        this.setIconVisibility(true)
        document.body.classList.toggle('lyt-Site-searchIsActive', true)
      }

      setIconVisibility (inputIsActive) {
        this.closeButton.setAttribute('aria-hidden', !inputIsActive)
        this.searchIcon.setAttribute('aria-hidden', inputIsActive)
      }
    },
  )
}
